import { render } from "./PlanStep3.vue?vue&type=template&id=1b1fbf7e&scoped=true"
import script from "./PlanStep3.vue?vue&type=script&lang=js"
export * from "./PlanStep3.vue?vue&type=script&lang=js"

import "./PlanStep3.vue?vue&type=style&index=0&id=1b1fbf7e&scoped=true&lang=stylus"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1fbf7e"]])

export default __exports__